"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowRight, CircleCheck, ExternalLink, Zap } from "lucide-react";
const services = [{
  title: "Residential Junk Removal",
  description: "Full-service removal for Ottawa homes. From basement cleanouts in Nepean to old furniture disposal in Kanata.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/ottawa_residential_junk_removal_service.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/ottawa_residential_junk_removal_service.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/ottawa_residential_junk_removal_service.png-wvc-sizes",
  alt: "Team removing a mattress from an Ottawa home",
  colorClass: "text-primary",
  link: "/HomePage"
}, {
  title: "Commercial Cleanouts",
  description: "Professional debris and office furniture removal for businesses across Kanata, Nepean, and downtown Ottawa.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/ottawa_commercial_office_cleanout_pro.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/ottawa_commercial_office_cleanout_pro.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/ottawa_commercial_office_cleanout_pro.png-wvc-sizes",
  alt: "Workers clearing out an office space in Kanata",
  colorClass: "text-primary",
  link: "/HomePage"
}, {
  title: "Furniture Removal",
  description: "We handle the heavy lifting in Orleans and Barrhaven. Couches, mattresses, and wardrobes hauled away responsibly.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/ottawa_furniture_pickup_specialist.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/ottawa_furniture_pickup_specialist.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/ottawa_furniture_pickup_specialist.png-wvc-sizes",
  alt: "Two workers carrying a heavy couch to a removal truck",
  colorClass: "text-primary",
  link: "/HomePage"
}, {
  title: "Appliance Disposal",
  description: "Eco-friendly recycling for old fridges and stoves across the Ottawa region, including Stittsville and Gloucester.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/ottawa_appliance_removal_recycling_center.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/ottawa_appliance_removal_recycling_center.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/ottawa_appliance_removal_recycling_center.png-wvc-sizes",
  alt: "Professional removal of an old refrigerator for recycling",
  colorClass: "text-primary",
  link: "/HomePage"
}, {
  title: "Estate & Moving Prep",
  description: "Comprehensive clearing services to help you prepare properties for sale in Rockcliffe Park or new tenants in Nepean.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/ottawa_estate_cleanout_specialist.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/ottawa_estate_cleanout_specialist.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/ottawa_estate_cleanout_specialist.png-wvc-sizes",
  alt: "Team performing a full garage cleanout in Nepean",
  colorClass: "text-primary",
  link: "/HomePage"
}, {
  title: "Yard Debris Removal",
  description: "Clearing branches and old garden structures to keep your property in Carp or Rockland looking pristine.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/ottawa_yard_waste_removal_crew.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/ottawa_yard_waste_removal_crew.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/ottawa_yard_waste_removal_crew.png-wvc-sizes",
  alt: "Workers loading yard waste and branches into a trailer",
  colorClass: "text-primary",
  link: "/HomePage"
}];
const serviceSuburbs = [{
  serviceTitle: "Furniture Removal",
  name: "Kanata",
  to: "/JunkRemovalKanataPage"
}, {
  serviceTitle: "Furniture Removal",
  name: "Nepean",
  to: "/JunkRemovalNepeanPage"
}, {
  serviceTitle: "Furniture Removal",
  name: "Orleans",
  to: "/JunkRemovalOrleansPage"
}, {
  serviceTitle: "Appliance Disposal",
  name: "Barrhaven",
  to: "/JunkRemovalBarrhavenPage"
}, {
  serviceTitle: "Appliance Disposal",
  name: "Stittsville",
  to: "/JunkRemovalStittsvillePage"
}, {
  serviceTitle: "Appliance Disposal",
  name: "Gloucester",
  to: "/JunkRemovalGloucesterPage"
}, {
  serviceTitle: "Yard Debris Removal",
  name: "Kanata",
  to: "/JunkRemovalKanataPage"
}, {
  serviceTitle: "Yard Debris Removal",
  name: "Orleans",
  to: "/JunkRemovalOrleansPage"
}, {
  serviceTitle: "Yard Debris Removal",
  name: "Nepean",
  to: "/JunkRemovalNepeanPage"
}];
export default function ServiceOfferingsGrid() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: bannerRef,
    isVisible: isBannerVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="258793" id="our-specialized-removal-services" className="py-24 bg-background text-foreground relative overflow-hidden">
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#8080800a_1px,transparent_1px),linear-gradient(to_bottom,#8080800a_1px,transparent_1px)] bg-[size:24px_24px] pointer-events-none" />

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        
        <div ref={headerRef} className={`text-center max-w-3xl mx-auto mb-16 transition-all duration-700 ${isHeaderVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <span className="text-sm font-bold tracking-widest uppercase text-primary mb-4 block font-default">
            Professional Solutions
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-6 font-default tracking-tight">
            Junk Removal Made Simple — Professional Solutions for Ottawa Homes & Businesses
          </h2>
          <p className="text-lg text-muted-foreground font-default">
            Fast, friendly junk removal across Ottawa, Kanata, and Orleans. We handle the heavy lifting so you don't have to.
          </p>
        </div>

        <div ref={gridRef} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {services.map((service, i) => <Card key={i} data-index={i} className={`relative overflow-hidden border-border/40 shadow-md hover:shadow-lg hover:border-primary/50 transition-all duration-300 hover:-translate-y-2.5 flex flex-col gap-0 group bg-card rounded-2xl ${isGridVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`} style={{
          transitionDelay: `${i * 100}ms`
        }}>
              <div className="relative h-48 overflow-hidden">
                <img src={service.image} data-wvc-srcset={service.srcset} data-wvc-sizes={service.sizes} alt={service.alt} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" />
                <div className="absolute inset-0 bg-gradient-to-t from-card/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                
                <div className="absolute top-4 left-4 z-20">
                  <Badge className="bg-secondary text-secondary-foreground font-bold border-none shadow-sm flex items-center gap-1 rounded-lg">
                    <Zap className="w-3 h-3 fill-current" /> Same-day available
                  </Badge>
                </div>
              </div>

              <div className="p-8 flex flex-col flex-grow">
                <h3 className="text-xl font-bold text-foreground mb-3 font-default relative z-10">
                  {service.title}
                </h3>
                
                <p className="text-muted-foreground mb-6 flex-grow relative z-10 font-default">
                  {service.description}
                </p>

                <div className="flex flex-col gap-4 relative z-10">
                  <div className="flex flex-wrap items-center gap-4">
                    <Button asChild className="bg-secondary text-secondary-foreground hover:bg-secondary/90 font-bold rounded-lg">
                      <Link to="#">Quick Quote</Link>
                    </Button>
                    
                    <Link to={service.link} className={`inline-flex items-center font-bold text-sm ${service.colorClass} hover:text-secondary transition-colors w-fit`}>
                      View Details <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1" />
                    </Link>
                  </div>

                  <div className="flex flex-wrap gap-x-3 gap-y-1 pt-2 border-t border-border/40">
                    {serviceSuburbs.filter(suburb => suburb.serviceTitle === service.title).map((suburb, subIndex) => <Link key={subIndex} to={suburb.to} className="text-xs font-bold text-muted-foreground hover:text-primary transition-colors">
                          {suburb.name}
                        </Link>)}
                  </div>
                </div>
              </div>
            </Card>)}
        </div>

        <div ref={bannerRef} className={`max-w-5xl mx-auto transition-all duration-700 delay-300 ${isBannerVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <Card className="bg-card/50 backdrop-blur-sm border-border/50 shadow-xl p-8 md:p-12 flex flex-col md:flex-row items-center gap-8 md:gap-12 overflow-hidden relative rounded-2xl">
            <div className="absolute top-0 right-0 w-64 h-64 bg-primary/10 rounded-lg blur-3xl -z-10 opacity-50 translate-x-1/2 -translate-y-1/2" />
            
            <div className="w-full md:w-2/5 shrink-0">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/ottawa_junk_removal_truck_fleet.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/ottawa_junk_removal_truck_fleet.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672912/img/ottawa_junk_removal_truck_fleet.png-wvc-sizes" alt="JUNKR Ottawa Service Truck" className="w-full h-auto rounded-lg shadow-md border border-border/20" loading="lazy" />
            </div>
            
            <div className="w-full md:w-3/5 flex flex-col items-start">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-lg bg-primary text-primary-foreground text-xs font-bold tracking-wider uppercase mb-5">
                <CircleCheck className="w-4 h-4" /> Locally Owned & Operated
              </div>
              
              <h3 className="text-2xl md:text-3xl font-bold text-foreground mb-4 font-default">
                Eco-Friendly Disposal + Same-Day Service — JUNKR's Ottawa Difference
              </h3>
              
              <p className="text-muted-foreground mb-6 leading-relaxed font-default">
                We don't just dump — we donate, recycle, and partner with local Ottawa charities.
              </p>
              
              <Link to="/AboutPage" className="inline-flex items-center font-bold text-primary hover:text-secondary transition-colors group">
                Our Sustainability Mission 
                <ExternalLink className="ml-2 w-4 h-4 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
              </Link>
            </div>
          </Card>
        </div>

      </div>
    </section>;
}